import "./style.css";
import { ListaAnexos } from "./ListaAnexos";
import { BlueHoverButton } from "../../../components/Inputs/BlueHoverButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box } from "@mui/material";
import { faInbox } from "@fortawesome/free-solid-svg-icons";

const Anexos = ({ setOpenPopup, recordForEdit, anexos }) => {
    return (
        <div style={{ width: "100%", minWidth: 600, height: 510 }}>
            <div>
                {anexos && anexos.length > 0 ? (
                    <ListaAnexos anexosAnalise={anexos} />
                ) : (
                    <div className="SemAnexos">
                        <FontAwesomeIcon icon={faInbox} />
                        <Box sx={{ mt: 1 }}>Nenhum registro encontrado</Box>
                    </div>
                )}
            </div>

            <div style={{
                margin: "30px 0px",
                display: "flex",
                justifyContent: "flex-end",
                gap: "20px"
            }}>
                <BlueHoverButton onClick={() => setOpenPopup(false)}>Fechar</BlueHoverButton>
            </div>
        </div>
    )
}

export { Anexos };